import React from "react";

const AuthorBox = ({ author }) => {
  if (!author) return null;
  const name = author.user?.username || author.username || "Unknown";

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body d-flex gap-3 align-items-center">
        <img
          src={author.avatar || "https://via.placeholder.com/80x80?text=A"}
          alt={name}
          className="rounded-circle"
          width={80}
          height={80}
        />
        <div>
          <h5 className="mb-1">{name}</h5>
          {author.bio && <p className="text-muted mb-2">{author.bio}</p>}
          <div className="d-flex gap-2">
            <a href="#" className="btn btn-sm btn-outline-secondary">Follow</a>
            <a href={`/author/${name}`} className="btn btn-sm btn-primary">View profile</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorBox;
